module.exports = __webpack_public_path__ + "static/media/n23.af277af5.jpg";